import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { z } from 'zod';

export const adminImpersonateRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/tools/impersonate',
  validateSearch: z.object({
    resourceId: z.number().optional(),
    resourceType: z.enum(['Lab', 'Group', 'Pharmacy']).default('Group'),
    roleId: z.number().optional(),
  }),
}).lazy(() =>
  import('pages/admin/Impersonate/AdminImpersonatePage/AdminImpersonatePage').then((d) => d.Route)
);
